import React from 'react';
import { motion } from 'framer-motion';
import { Github, Mail, ArrowUp } from 'lucide-react';
import { profileData } from '../utils/mockData';
import { useLocation } from 'react-router-dom';
import ArunkubeLogo from './ArunkubeLogo';
import { useSpaceExperience } from './SpaceExperience';

const Footer = () => {
  const space = useSpaceExperience();
  const { pathname } = useLocation();
  const home = pathname === '/' ? '' : '/';
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    document.getElementById('portfolio-main')?.focus({ preventScroll: true });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Footer Content */}
        <div className="footer-content">
          {/* Logo & Description */}
          <div className="footer-brand">
            <div className="footer-logo">{space ? <ArunkubeLogo /> : 'Arun Bharathwaj'}</div>
            <p className="footer-tagline">
              {space ? `${profileData.name} · Cloud Native · ${profileData.title}` : 'Senior Platform Engineer building secure, scalable cloud-native infrastructure'}
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4 className="footer-title">Quick Links</h4>
            <a href={`${home}#about`} className="footer-link">
              About
            </a>
            <a href={`${home}#skills`} className="footer-link">
              Skills
            </a>
            <a href={`${home}#projects`} className="footer-link">
              Projects
            </a>
            <a href={`${home}#resume`} className="footer-link">
              Resume
            </a>
            <a href="/blogs" className="footer-link">Blogs</a>
          </div>

          {/* Connect */}
          <div className="footer-connect">
            <h4 className="footer-title">Connect</h4>
            <a href={`mailto:${profileData.email}`} className="footer-link">
              <Mail size={16} />
              Email
            </a>
            <a
              href={profileData.github}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              <Github size={16} />
              GitHub
            </a>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} {profileData.name}. Built with precision and care.
          </p>
          <motion.button
            className="scroll-top-button"
            aria-label="Back to top"
            onClick={scrollToTop}
            whileHover={{ y: -4 }}
            whileTap={{ scale: 0.9 }}
          >
            <ArrowUp size={20} />
          </motion.button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
